import { createAction, props } from "@ngrx/store";

export const setGeneralValues = createAction(
    '[General] set general values',
    props<{ values: any }>()
);

